import { FC } from 'react';
import { UnexpectedErrorRequiresLogin } from '@components/errorHandler';

export const ErrorBoundary: FC = () => {
    return <UnexpectedErrorRequiresLogin />;
};
